// Central helper for every outbound link to recalibratepain.app.
//
// Why this exists:
//   - The teardown identified that buyer-intent CTAs were being sent to the .app
//     root (homepage of the app, behind the freemium signup wall) instead of the
//     purpose-built /pricing page that shows the Welcome Offer up front.
//   - No outbound link carried UTMs, so once a user landed on .app we lost all
//     source attribution.
//
// Using appUrl(...) everywhere gives us one place to tweak destinations,
// add/remove parameters, or swap campaign tags.
//
// Usage:
//   import { appUrl, APP_PRICING_URL, APP_ROOT_URL } from '../utils/appUrl';
//
//   <a href={appUrl('/pricing', 'hero-get-started', 'home')}>Get Started</a>
//   <a href={APP_PRICING_URL}>See Plans</a>     // convenience for static needs
//
const APP_BASE = process.env.REACT_APP_APP_URL;

/**
 * Build an outbound recalibratepain.app URL with UTM attribution.
 *
 * @param {string} path       e.g. '/pricing', '/offer', '/' - defaults to root
 * @param {string} source     short slug identifying the CTA (matches data-testid where possible)
 * @param {string} campaign   page bucket: 'home', 'blog', 'features', 'condition', 'popup', 'email', ...
 * @returns {string} fully-qualified URL with UTMs
 */
export function appUrl(path = '/', source = 'unknown', campaign = 'general') {
  const url = new URL(path, APP_BASE);
  url.searchParams.set('utm_source', 'recalibrate-com');
  url.searchParams.set('utm_medium', 'referral');
  url.searchParams.set('utm_campaign', campaign);
  url.searchParams.set('utm_content', source);
  return url.toString();
}

// Convenience constants for the two most common destinations.
export const APP_PRICING_URL = appUrl('/pricing', 'static-link', 'general');
export const APP_ROOT_URL = appUrl('/', 'static-link', 'general');
